import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";
import { ExtracaoEntidade } from "../models/extracao-dados/extracaoEntidade";
import { ExtracaoMetadata } from "../models/extracao-dados/extracaoMetadata";
import {
  ExtracaoPreviewRequest,
  ExtracaoPreviewResponse
} from "../models/extracao-dados/extracaoPreviewRequest";

@Injectable({
  providedIn: 'root'
})
export class ExtracaoDadosService {
  private api = ConvivaApi;

  constructor(private http: HttpClient) { }

  public listarEntidades(): Observable<ExtracaoEntidade[]> {
    return this.http.get<DefaultResponse | ExtracaoEntidade[]>(`${this.api.Extracao.GetEntidades}`)
      .pipe(map((response) => this.unwrap<ExtracaoEntidade[]>(response, [])));
  }

  public obterMetadata(entidadeId: number): Observable<ExtracaoMetadata> {
    return this.http.get<DefaultResponse | ExtracaoMetadata>(`${this.api.Extracao.GetMetadata}/${entidadeId}/metadata`)
      .pipe(map((response) => this.unwrap<ExtracaoMetadata>(response, null as any)));
  }

  public inicializarEntidades(): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse | null>(`${this.api.Extracao.PostInicializarEntidades}`, null)
      .pipe(map((response) => {
        if (response?.isSucess === false) {
          throw new Error(response.message || 'Ocorreu um erro ao processar a requisição.');
        }

        return response ?? { isSucess: true };
      }));
  }

  public preview(request: ExtracaoPreviewRequest): Observable<ExtracaoPreviewResponse> {
    return this.http.post<DefaultResponse | ExtracaoPreviewResponse>(`${this.api.Extracao.PostPreview}`, request)
      .pipe(map((response) => this.unwrap<ExtracaoPreviewResponse>(response, null as any)));
  }

  public exportarCsv(request: ExtracaoPreviewRequest): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.api.Extracao.PostExportarCsv}`, request, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  public exportarExcel(request: ExtracaoPreviewRequest): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.api.Extracao.PostExportarExcel}`, request, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  private unwrap<T>(response: any, fallback: T): T {
    if (response == null) return fallback;
    if (typeof response === 'object' && 'isSucess' in response) {
      if (response.isSucess === false) {
        throw new Error(response.message || 'Ocorreu um erro ao processar a requisição.');
      }
      return (response.data ?? fallback) as T;
    }
    return response as T;
  }
}
